<template>
  <div>
    <!-- :style="{transform: 'translateX(' + scale + ')'}" -->
    <HeaderTab :isbg="isScroll" />
    <!-- <keep-alive>
      <RouterView v-if="$route.meta.keepAlive" :class="$route.meta.bg ? 'pt100' : ''" />
    </keep-alive> -->
    <RouterView :class="$route.meta.bg ? 'pt80' : ''" />
    <BottomBanner />
  </div>
</template>

<script>
import HeaderTab from './components/HeaderTab.vue';
import BottomBanner from './components/BottomBanner.vue';
export default {
  name: 'App',
  components: {
    HeaderTab,
    BottomBanner
  },
  data() {
    return {
      isScroll: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      let scrollHeight = window.pageYOffset;
      if (scrollHeight > 100) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },
  }
}
</script>

<style>
html,
body,
#app {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
  padding: 0;
  margin: 0;
}

* {
  margin: 0;
  padding: 0;
  text-decoration: none;
}

.out-box {
  width: 100%;
}

.inner-box {
  width: 94%;
  max-width: 1300px;
  margin: 0 auto;
}

.pt80 {
  padding-top: 80px;
}

.title1 {
  font-weight: 700;
  font-size: 35px;
  color: #E1E2E5;
  line-height: 49px;
  white-space: nowrap;
}

.title2 {
  font-weight: 600;
  font-size: 30px;
  color: #1D1E1F;
  line-height: 42px;
  transform: translateY(-25px);
}

img {
  vertical-align: middle;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
  transform: translateX();
}

@keyframes big {
  0% {
    opacity: 0;
    transform: scale(0.3)
  }

  100% {
    opacity: 1;
    transform: scale(1)
  }
}

.see {
  animation: big 2s ease;
}

@keyframes upin {
  0% {
    opacity: 0;
    transform: translateY(100px)
  }

  100% {
    opacity: 1;
    transform: translateY(0)
  }
}

.see2 {
  animation: upin 2s ease;
}

@keyframes big2 {
  0% {
    transform: scale(1)
  }

  100% {
    transform: scale(1.3)
  }
}

.hover {
  animation: big2 2s ease;
}

.animation1 {
  transform: scale(1);
  transition: transform 1s ease;
}

.animation1:hover {
  transform: scale(1.3);
}

.animation2 {
  transform: translateY(0);
  transition: transform 1s ease;
}

.animation2:hover {
  transform: translateY(-40px);
}

@media screen and (max-width: 768px) {
  .title1 {
    font-size: 30px;
    line-height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .title2 {
    font-size: 24px;
    line-height: 32px;
    transform: translateY(-18px);
  }

  .pt80 {
    padding-top: 50px;
  }

  .animation2 {
    transform: translateY(0);
    transition: none;
  }

  .animation2:hover {
    transform: none;
  }

}
</style>
